import { home } from "../content/home";
import { CodeCardSketch } from "./CodeCardSketch";
import { SlackCardSketch } from "./SlackCardSketch";
import { PrCardSketch } from "./PrCardSketch";

const { label, headline, items } = home.features;

// One moving sketch per feature: a small call beside the Intakall sidebar, a card popping in.
const SKETCHES = [
  <CodeCardSketch key="code" />,
  <SlackCardSketch key="slack" />,
  <PrCardSketch key="pr" />,
];

export function FeaturesSection() {
  return (
    <section id="features" aria-label={label} className="scroll-mt-20 px-4 py-24 sm:px-6 lg:py-28">
      <div className="mx-auto max-w-6xl">
        <h2 className="max-w-3xl font-serif text-[clamp(2.25rem,4.5vw,3.5rem)] font-medium leading-[1.02] tracking-[-0.015em] text-char">
          {headline.line1}
          <br />
          <em className="text-brand-500">{headline.line2}</em>
        </h2>

        <div className="mt-14 grid border-t border-char/20 md:grid-cols-3">
          {items.map((item, i) => (
            <article
              key={item.title}
              className="flex flex-col gap-4 border-b border-char/20 py-8 md:border-b-0 md:border-l md:px-8 md:py-10 md:first:border-l-0 md:first:pl-0 md:last:pr-0"
            >
              {/* Same height in every column so the titles line up; the code card animates in the first. */}
              <div className="flex items-end md:h-[230px]" aria-hidden="true">
                {SKETCHES[i]}
              </div>
              <h3 className="mt-2 font-serif text-[26px] leading-tight text-char">{item.title}</h3>
              <p className="font-sans text-base leading-relaxed text-char/75">{item.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
